import { isInternalEmail } from '@/helpers/feature-flags'

import { UUID } from '@/types/Id'
import { Task } from '@/types/task/Task'
import { User } from '@/types/User'

// requests are worked by the Sweetspot team, so only staff can be assigned
export const canBeRequestAssignee = (user: User) => isInternalEmail(user.email)

export const getTaskListPath = (orgId: UUID | '', task: Task) => {
  switch (task.type) {
    case 'pursuit_task':
      if (task.pursuit_task && orgId) {
        const tab = task.is_request ? 'requests' : 'tasks'
        return `/orgs/${orgId}/pursuits/${task.pursuit_task.pursuit_id}/${tab}`
      }
      return ''
    case 'organization_task':
      return ''
    default:
      const exhaustiveCheck: never = task.type
      throw new Error(`Unsupported task type: ${task.type}`)
  }
}

export const getTaskPath = (orgId: UUID | '', task: Task) => {
  const listPath = getTaskListPath(orgId, task)
  return listPath ? `${listPath}/${task.id}` : ''
}

export const compareTaskDueDates = (a: Date | null, b: Date | null) => {
  if (a === null) return b === null ? 0 : 1
  if (b === null) return -1
  return a.getTime() - b.getTime()
}
